<template>
    <div class="my-order">
        <mt-navbar v-model="selected" :fixed="true">
            <mt-tab-item @click.native="navbarItemClick" id="0">我邀请的代理人</mt-tab-item>
            <mt-tab-item @click.native="navbarItemClick" id="1">我邀请的老师</mt-tab-item>
        </mt-navbar>
        <mt-tab-container v-model="selected" v-infinite-scroll="loadMoreInfo"
                            infinite-scroll-disabled="aloading"
                            infinite-scroll-distance="10">
            <mt-tab-container-item id="0">
                <div class="list-table" v-for="(item) in my_agent" :key="item.ID">
                    <div class="table-left">
                        <img style="width: 50px;height: 50px;" src="../../assets/man_img.png" alt="">
                    </div>
                    <div class="table-right">
                        <div class="right-info2">
                            <div>{{item.Linkman}}</div>
                            <div style="text-align: right">{{item.Phone}}</div>
                        </div>
                        <div class="right-area">
                            <div>销售区域：</div>
                            <div>
                                <span v-if="item.AreaList.length==0">无</span>
                                <span v-for="(list) in item.AreaList" :key="list.ID">{{list.AreaName}} </span>
                            </div>
                        </div>
                        <div class="right-time">
                            <div>注册时间：</div>
                            <div>{{item.datas}}</div>
                        </div>
                        <div class="right-bot">
                            <div><span>当前库存 </span><span style="color: red">{{item.InAmount-item.UsedAmount}}</span> 件</div>
                            <div><span>累计售出 </span><span style="color: green">{{item.UsedAmount}}</span> 件</div>
                        </div>
                    </div>
                </div>
                <h3 v-if="my_agent.length<=0">暂无邀请代理商</h3>
                <p v-if="show_line&&my_agent.length!=0" class="data-base-line">到底了</p>
            </mt-tab-container-item>
            <mt-tab-container-item id="1">
                <div class="list-table" v-for="(item) in my_teacher" :key="item.ID">
                    <div class="table-left">
                        <img style="width: 50px;height: 50px;" src="../../assets/man_img.png" alt="">
                    </div>
                    <div class="table-right">
                        <div class="right-info2">
                            <div>{{item.UserName}}</div>
                            <div style="text-align: right">{{item.Account||item.Phone}}</div>
                        </div>
                        <div class="right-time">
                            <div>所在学校：</div>
                            <div>{{item.SchoolName}}</div>
                        </div>
                        <div class="right-timestate">
                            <div class="time">
                                <div>注册时间：</div>
                                <div>{{item.datas}}</div>
                            </div>
                            <div class="state" :style="{'color': item.boolState?'#72c34c':'#c3524c'}">{{item.userState}}</div>
                        </div>
                    </div>
                </div>
                <h3 v-if="my_teacher.length<=0">暂无邀请老师</h3>
                <p v-if="show_line&&my_teacher.length!=0" class="data-base-line">到底了</p>
            </mt-tab-container-item>
        </mt-tab-container>
    </div>
</template>
<script>
export default {
    data() {
        return{
            selected: '0',
            // 我的代理商
            my_agent: [],
            // 我的老师
            my_teacher: [],
            aloading: false,
            reqData: {
                PageIndex: 0,
                PageSize: 15
            },
            show_line: false
        }
    },
    methods: {
        navbarItemClick() {
            let _this = this;
            _this.$indicator.open('加载中...');
            _this.aloading = true;
            _this.show_line = false;
            _this.reqData.PageIndex = 1;
            if(_this.selected == 0) {
                _this.abp.api.AgentRetrieveAgent(_this.reqData)
                    .then((res)=> {
                        _this.$indicator.close();
                        if(res.status == 200) {
                            if(res.data.IsSuccess) {
                                if(res.data.Data.length < _this.reqData.PageSize) {
                                    _this.show_line = true;
                                    _this.aloading = true;
                                }else{
                                    this.aloading = false;
                                }
                                res.data.Data.forEach(ele => {
                                    ele.datas = _this.$moment(ele.JoinDate).calendar();
                                })
                                _this.my_teacher = [];
                                _this.my_agent = res.data.Data;
                            }else{
                                _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                            }
                        }
                    })
                    .catch((error)=>{
                        _this.$indicator.close();
                        try {
                            switch(error.status) {
                                case 401:
                                _this.abp.api.reqSuccess(_this,'您没有权限！')
                            }
                        } catch (txt) {
                            console.log(txt);
                        }
                    })
            }else{
                _this.abp.api.AgentReadTeacher(_this.reqData)
                    .then((res)=> {
                        _this.$indicator.close();
                        if(res.status == 200) {
                            if(res.data.IsSuccess) {
                                if(res.data.Data.length < _this.reqData.PageSize) {
                                    _this.show_line = true;
                                    _this.aloading = true;
                                }else{
                                    this.aloading = false;
                                }
                                res.data.Data.forEach(ele => {
                                    if(ele.MouseID) {
                                        ele.boolState = false;
                                        if(ele.State == 0) {
                                            ele.userState = '审核中';
                                        }else if(ele.State == 1){
                                            ele.boolState = true;
                                            ele.userState = '邀请成功';
                                        }else{
                                            ele.userState = '邀请失败';
                                        }
                                    }else{
                                        ele.boolState = false;
                                        ele.userState = '未绑定鼠标码';
                                    }
                                    ele.datas = _this.$moment(ele.UsedDate).calendar();
                                })
                                _this.my_agent = [];
                                _this.my_teacher = res.data.Data;
                            }else{
                                _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                            }
                        }
                    })
                    .catch((error)=>{
                        _this.$indicator.close();
                        try {
                            switch(error.status) {
                                case 401:
                                _this.abp.api.reqSuccess(_this,'您没有权限！')
                            }
                        } catch (txt) {
                            console.log(txt);
                        }
                    })
            }
        },
        loadMoreInfo() {
            let _this = this;
            _this.$indicator.open('加载中...');
            _this.aloading = true;
            _this.reqData.PageIndex = (_this.reqData.PageIndex+1);
            if(_this.selected == 0) {
                _this.abp.api.AgentRetrieveAgent(_this.reqData)
                    .then((res)=> {
                        _this.$indicator.close();
                        if(res.status == 200) {
                            if(res.data.IsSuccess) {
                                if(res.data.Data.length < _this.reqData.PageSize) {
                                    _this.show_line = true;
                                    _this.aloading = true;
                                }else{
                                    this.aloading = false;
                                }
                                res.data.Data.forEach(ele => {
                                    ele.datas = _this.$moment(ele.JoinDate).calendar();
                                })
                                _this.my_agent = _this.my_agent.concat(res.data.Data);
                            }else{
                                _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                            }
                        }
                    })
                    .catch((error)=>{
                        _this.$indicator.close();
                        try {
                            switch(error.status) {
                                case 401:
                                _this.abp.api.reqSuccess(_this,'您没有权限！')
                            }
                        } catch (txt) {
                            console.log(txt);
                        }
                    })
            }else{
                _this.abp.api.AgentReadTeacher(_this.reqData)
                    .then((res)=> {
                        _this.$indicator.close();
                        if(res.status == 200) {
                            if(res.data.IsSuccess) {
                                if(res.data.Data.length < _this.reqData.PageSize) {
                                    _this.show_line = true;
                                    _this.aloading = true;
                                }else{
                                    this.aloading = false;
                                }
                                res.data.Data.forEach(ele => {
                                    if(ele.MouseID) {
                                        ele.boolState = false;
                                        if(ele.State == 0) {
                                            ele.userState = '审核中';
                                        }else if(ele.State == 1){
                                            ele.boolState = true;
                                            ele.userState = '邀请成功';
                                        }else{
                                            ele.userState = '邀请失败';
                                        }
                                    }else{
                                        ele.boolState = false;
                                        ele.userState = '未绑定鼠标码';
                                    }
                                    ele.datas = _this.$moment(ele.UsedDate).calendar();
                                })
                                _this.my_teacher = _this.my_teacher.concat(res.data.Data);
                            }else{
                                _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                            }
                        }
                    })
                    .catch((error)=>{
                        _this.$indicator.close();
                        try {
                            switch(error.status) {
                                case 401:
                                _this.abp.api.reqSuccess(_this,'您没有权限！')
                            }
                        } catch (txt) {
                            console.log(txt);
                        }
                    })
            }
        }
    }
}
</script>
<style scoped>
    .my-order .mint-navbar.is-fixed {
        top: 0;
        left: 0;
        right: 0;
        overflow: hidden;
    }
    .my-order .mint-tab-container {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        overflow: auto;
        top: 50px;
        background-color: #eee;
    }
    .my-order .mint-navbar {
        cursor: pointer;
    }
    .my-order .mint-navbar>a:hover {
        background-color: #c2dcf0;
        color: #fff;
    }
    .my-order .mint-navbar /deep/.mint-tab-item-label {
        font-size: 14px;
    }
    .my-order .mint-tab-container-item>h3 {
        color: #999;
        margin-top: 200px;
        text-align: center;
    }
    .mint-navbar /deep/.mint-tab-item.is-selected {
        color: #000;
        font-weight: 800;
        margin-bottom: 0px;
        border-bottom: 2px solid #26a2ff;
    }
    .my-order .mint-navbar>a:hover {
        color: #000;
        background-color: #fff;
    }
    .my-order table{
        table-layout: fixed;
        word-break: break-all;
        word-wrap: break-word;
    }
    .my-order .list-table {
        background-color: #fff;
        margin: 10px 5px 0;
        padding: 10px;
        border-radius: 5px;
        display: flex;
        align-items: center;
    }
    .my-order .list-table>.table-left {
        width: 50px;
        height: 50px;
        margin: 10px;
    }
    .my-order .list-table>.table-right {
        flex: 1;
    }
    .my-order .list-table>.table-right>.right-info {
        display: flex;
        align-items: center;
        padding: 10px 0;
    }
    .my-order .list-table>.table-right>.right-info2 {
        display: flex;
        align-items: center;
        padding: 10px 0;
    }
    .my-order .list-table>.table-right>.right-info2>div {
        flex: 1;
    }
    .my-order .list-table>.table-right>.right-info>div:first-child {
        width: 65px;
    }
    .my-order .list-table>.table-right>.right-info>div:last-child {
        width: 100px;
    }
    .my-order .list-table>.table-right>.right-area,
    .my-order .list-table>.table-right>.right-time,
    .my-order .list-table>.table-right>.right-timestate {
        display: flex;
        font-size: 14px;
        color: #555;
        padding: 5px 0;
        align-items: center;
        background-color: #fafafa;
    }
    .my-order .list-table>.table-right>.right-timestate>.time {
        flex: 2;
        display: flex;
        align-items: center;
    }
    .my-order .list-table>.table-right>.right-timestate>.state {
        flex: 1;
        display: flex;
        font-size: 12px;
        justify-content: flex-end;
    }
    .my-order .list-table>.table-right>.right-time {
        align-items: center;
    }
    .my-order .list-table>.table-right>.right-area>div:first-child,
    .my-order .list-table>.table-right>.right-time>div:first-child,
    .my-order .list-table>.table-right>.right-timestate>.time>div:first-child {
        width: 75px;
    }
    .my-order .list-table>.table-right>.right-area>div:last-child,
    .my-order .list-table>.table-right>.right-time>div:last-child,
    .my-order .list-table>.table-right>.right-timestate>.time>div:last-child  {
        flex: 1;
    }
    .my-order .list-table>.table-right>.right-bot {
        display: flex;
        align-items: center;
        padding: 10px 0;
    }
    .my-order .list-table>.table-right>.right-bot>div {
        flex: 1;
    }
    .my-order .list-table>.table-right>.right-bot>div:last-child {
        text-align: right;
        align-items: center;
    }
</style>
